const DEFAULT_LOGOUT_REDIRECT = "https://auditvault365.com";
const LOGOUT_FALLBACK_DELAY_MS = 8000;
const LOGOUT_IN_PROGRESS_KEY = "auditVault.logoutInProgress";

export function isLogoutInProgress() {
    return window.sessionStorage.getItem(LOGOUT_IN_PROGRESS_KEY) === "true";
}

export function clearLogoutInProgress() {
    window.sessionStorage.removeItem(LOGOUT_IN_PROGRESS_KEY);
}

export function getLogoutRedirectUri() {
    return process.env.REACT_APP_WEB_URL || DEFAULT_LOGOUT_REDIRECT;
}

export async function logoutFromMicrosoft(instance, accounts = []) {
    if (isLogoutInProgress()) {
        return;
    }

    window.sessionStorage.setItem(LOGOUT_IN_PROGRESS_KEY, "true");
    const postLogoutRedirectUri = getLogoutRedirectUri();
    const account = instance.getActiveAccount() || accounts[0] || null;
    const logoutHint = account?.idTokenClaims?.login_hint || account?.username;

    // If MSAL fails to start or complete navigation in this window, return the
    // user to the application instead of leaving the UI indefinitely blocked.
    window.setTimeout(() => {
        window.location.replace(postLogoutRedirectUri);
    }, LOGOUT_FALLBACK_DELAY_MS);

    try {
        await instance.logoutRedirect({
            account,
            logoutHint,
            postLogoutRedirectUri,
        });
    } catch (error) {
        console.error("Microsoft sign out redirect failed.", error);
        window.location.replace(postLogoutRedirectUri);
    }
}
